module.exports = __webpack_public_path__ + "static/images/components/UpgradeEffect/images/hover-borders.0d34aba1.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeEffect/images/hover-borders.png
// module id = 2693
// module chunks = 11